<template>
  <div>
    <button v-if="loader" type="button" class="button button-loader"></button>
    <button v-else @click="send(id)" class="button">
      <span :class="{ 'button-text-desktop': textMobile }">{{ text }}</span>
      <span v-if="textMobile" class="button-text-mobile">{{ textMobile }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "FriendsButton",
  props: {
    id: {
      type: Number,
      required: true,
    },
    action: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    textMobile: {
      type: String,
      required: false,
    },
    successMessage: {
      type: String,
      required: true,
    },
    callback: {
      type: Function,
      required: false,
    },
    i18n: Object,
  },
  data() {
    return {
      loader: false,
    };
  },
  methods: {
    send(id) {
      this.loader = true;
      this.$store
        .dispatch(this.action, id)
        .then(() => {
          this.$modal.show("dialog", {
            title: this.$t("threads.success"),
            text: this.successMessage,
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
          if (this.callback) {
            this.callback();
          }
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
        });
    },
  },
};
</script>
